<form [formGroup]="form">
  <div formArrayName="Categories">
    @for (category of categories; track category; let ci = $index) {
      <div
        class="category-wrapper"
        >
        <cst-card>
          <ng-template cstCardTitle>
            <span>{{ category.Label }}</span>
          </ng-template>
          <ng-template cstCardContent>
            <div [formGroupName]="ci" class="category-content-wrapper">
              @if (hasGroups(getCategoryByIndex(ci))) {
                <div class="groups-wrapper" formArrayName="Groups">
                  @for (
                    group of getGroups(getCategoryByIndex(ci)); track
                    group; let gi = $index) {
                    <h4>{{ group.Label }}</h4>
                    <div [formArrayName]="gi">
                      <div class="fields-wrapper">
                        @for (field of getFields(group); track field; let gfi = $index) {
                          <ng-container
                          *ngTemplateOutlet="
                            dynamicInput;
                            context: {
                              field: field,
                              type: inputTypeToHtmlType(
                                getInputType(field['InputType'])
                              ),
                              ctl: getCtl(ci, gi, gfi)
                            }
                          "
                        ></ng-container>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (hasFields(getCategoryByIndex(ci))) {
              <div class="fields-wrapper" formArrayName="Fields">
                @for (
                  field of getFields(getCategoryByIndex(ci)); track
                  field; let fi = $index) {
                  <ng-container
                    *ngTemplateOutlet="
                      dynamicInput;
                      context: {
                        field: field,
                        type: inputTypeToHtmlType(
                          getInputType(field['InputType'])
                        ),
                        ctl: getCtl(ci, fi, null)
                      }
                    "
                ></ng-container>
              }
            </div>
          }
        </div>
      </ng-template>
    </cst-card>
  </div>
}
</div>
</form>

<ng-template #dynamicInput let-field="field" let-type="type" let-ctl="ctl">
  @switch (type) {
    @case ('text') {
      <ng-container
        *ngTemplateOutlet="textInput; context: { field: field, ctl: ctl }"
      ></ng-container>
    }
    @case ('checkbox') {
      <div class="checkbox-wrapper">
        <ng-container
          *ngTemplateOutlet="chkBoxInput; context: { field: field, ctl: ctl }"
        ></ng-container>
      </div>
    }
    @case ('select') {
      <ng-container
        *ngTemplateOutlet="selectInput; context: { field: field, ctl: ctl }"
      ></ng-container>
    }
    @case ('textarea') {
      <ng-container
        *ngTemplateOutlet="textAreaInput; context: { field: field, ctl: ctl }"
      ></ng-container>
    }
    @case ('datetime-local') {
      <ng-container
        *ngTemplateOutlet="dateTimePicker; context: { field: field, ctl: ctl }"
      ></ng-container>
    }
    @default {
      UNKNOWN INPUT TYPE:
      {{ field["InputType"] }} (Parsed as: {{ type }})
    }
  }
</ng-template>

<ng-template #textInput let-field="field" let-ctl="ctl">
  <frm-text [label]="field['Label']" [formControl]="ctl"></frm-text>
</ng-template>

<ng-template #chkBoxInput let-field="field" let-ctl="ctl">
  <frm-check [label]="field['Label']" [formControl]="ctl" labelPosition="before"></frm-check>
</ng-template>

<ng-template #textAreaInput let-field="field" let-ctl="ctl">
  <frm-text
    [label]="field['Label']"
    [formControl]="ctl"
    [multiline]="true"
    [rows]="4"
  ></frm-text>
</ng-template>

<ng-template #dateTimePicker let-field="field" let-ctl="ctl">
  <frm-date-picker
    label="{{ field['Label'] }}"
    format="dd.MM.yyyy"
    [formControl]="ctl"
  ></frm-date-picker>
</ng-template>

<ng-template #selectInput let-field="field" let-ctl="ctl">
  <frm-text [label]="field['Label']" [formControl]="ctl"></frm-text>
</ng-template>